import React, { useState } from "react";
import "./ForgotPasswordModal.css";

const ForgotPasswordModal = ({ isOpen, onClose, onPasswordReset }) => {
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendReset = async () => {
    setError("");
    setMessage("");

    if (!emailOrPhone.trim()) {
      setError("Please enter your email or phone number.");
      return;
    }

    setLoading(true);
    try {
      if (onPasswordReset) {
        await onPasswordReset(emailOrPhone.trim());
      }
      setMessage("If an account exists, a password reset email has been sent. Please check your inbox.");
    } catch (err) {
      setError(err.message || "Failed to send password reset link.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmailOrPhone("");
    setMessage("");
    setError("");
    setLoading(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-forgot" onClick={handleClose}>
      <div className="modal-content-forgot" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-forgot" onClick={handleClose}>
          ✕
        </button>

        <div className="modal-body-forgot">
          <h2 className="modal-title-forgot">Forgot Password?</h2>
          <p className="modal-subtitle-forgot">
            Enter your email or phone number and we will send you a password reset link.
          </p>

          <input
            type="text"
            className="forgot-input"
            placeholder="Email or Phone Number"
            value={emailOrPhone}
            onChange={(e) => setEmailOrPhone(e.target.value)}
          />

          {error && <div className="error-message-forgot">{error}</div>}
          {message && <div className="success-message-forgot">{message}</div>}

          <button
            className="btn-primary-forgot"
            onClick={handleSendReset}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="spinner-border spinner-border-sm me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                Sending...
              </>
            ) : (
              "Send Reset Link"
            )}
          </button>

          <button className="btn-secondary-forgot" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
